define(function (require, exports, module) {
    'use strict';

    var config = require('Cloud/config');
    var fileSystemFileReader = require('../fs/fileSystemFileReader');
    var cloudFileSystem = require('./cloudFileSystem');
    var UploadReason = require('../../UploadReason');
    var FileWithoutHashFail = require('../../fails/FileWithoutHashFail');

    /**
     * @namespace
     */
    var backendRequest = {
        /**
         * @type {number}
         */
        FILE_WITHOUT_HASH_MAX_SIZE: config.get('ITEM_WITHOUT_HASH_MAX_SIZE'),

        /**
         * @param {File} file
         * @returns {Promise}
         * @resolves {string}
         * @rejects {UploadReason|Error}
         */
        getHexCode: function (file) {
            var promise;

            if (file.size > backendRequest.FILE_WITHOUT_HASH_MAX_SIZE) {
                promise = Promise.reject(new Error('too large'));
            } else {
                promise = fileSystemFileReader.getHexCode(file);

                promise = promise.then(function (hexCode) {
                    var cloudHexCode = cloudFileSystem.EMPTY_FILE_HASH;

                    // Так как байткод файла помещается в базу вместо hash,
                    // необходимо дополнить байткод до 40 байт нулевыми значениями.
                    // Например: строка '123' имеет байткод в шестнадцатеричном виде '313233',
                    // а в API нужно отправить '3132330000000000000000000000000000000000'.
                    cloudHexCode = hexCode + cloudHexCode.slice(hexCode.length);

                    return cloudHexCode;
                });
            }

            return promise;
        },

        /**
         * @param {File} file
         * @param {string} method
         * @returns {Promise}
         * @resolves {FormData|Blob}
         * @rejects {Error}
         */
        getFullBody: function (file, method) {
            var promise;

            if (file.size <= backendRequest.FILE_WITHOUT_HASH_MAX_SIZE) {
                // Для файлов размером меньше 21 байта
                // вместо hash в базу помещается байткод.
                var source = UploadReason.SOURCE_WEB_CLIENT;
                var stack = new Error('FileWithoutHashFail');
                var reason = new FileWithoutHashFail(stack, source);

                promise = Promise.reject(reason);
            } else if (method === 'POST') {
                promise = fileSystemFileReader.getMultipartFormData(file);
            } else if (method === 'PUT') {
                // Для файлов размером больше 21 байт
                // сразу резолвим инстанс File,
                // так как он также является инстансом Blob,
                // а XMLHttpRequest умеет отправлять блобы.
                promise = Promise.resolve(file);
            } else {
                promise = Promise.reject(new TypeError('unsuported HTTP method'));
            }

            return promise;
        },

        /**
         * @returns {Promise}
         * @rejects {Error}
         */
        getChunkBody: function () {
            return Promise.reject(new Error('not implemented'));
        },
    };

    module.exports = backendRequest;
});
